
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ggoVZyuDI2KZlWkWKi8bYMCPmKLQSnaVAl7aruCGkGx8Meta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexF4bD_ej_WdKPE2X6GNq33L21Rz9z311z77d1BbAoV44Meta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchsm_45CqviGJ3nePVOmtHd7GVINh03_RBQzKg8MNLyUfsEMeta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexV1_al9_45mazmTHsvZQzn88AxegTgOStev2e_ZW3eYtm8Meta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93B4QDMN2V8vkzURrcQIvEUBUwjWxYjAibDbqE16if_45_45AMeta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexYFM_WY4BhzPjtjVS56qN6VWrHohli8F9poZ3mwXyZI4Meta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93BpdAa8zFFbL_45PTQklD3bgzoki9PvpQmbZSQmiLwoFiQMeta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index9OuTwaA5lAjZR8YNTd_45lQklLXzdmNCUxxaMJsmaIS8gMeta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_933WzmK7o_8JS__456Qt9eDglbsCrsANDfuokLu3Mfq1gI4Meta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index6GUo0KnYAHBQbhZwU__47v_45FxNd8DO_lN76sKRHpgk0Meta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexlhVtWPUwdAnzx5dMxOpXF3Wb_45i4x6jtrshfUeOkd4l8Meta } from "/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexYFM_WY4BhzPjtjVS56qN6VWrHohli8F9poZ3mwXyZI4Meta || {},
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index9OuTwaA5lAjZR8YNTd_45lQklLXzdmNCUxxaMJsmaIS8gMeta || {},
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index6GUo0KnYAHBQbhZwU__47v_45FxNd8DO_lN76sKRHpgk0Meta || {},
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexlhVtWPUwdAnzx5dMxOpXF3Wb_45i4x6jtrshfUeOkd4l8Meta || {},
    component: () => import("/codebuild/output/src3493779333/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]